<template>
  <v-card v-if="psp" flat color="transparent" outlined class="pa-4">
    <!-- Título + Stock actual -->
    <v-row align="center" class="mb-4">
      <v-col cols="12" md="6">
        <div class="d-flex align-center mb-3">
          <h2 class="font-weight-bold mr-3">Gestión de Stock</h2>
          <v-chip small :color="tipoStockColor" dark>{{ tipoStockLabel }}</v-chip>
        </div>

        <v-row class="d-flex align-center">
          <v-col cols="12" md="6" v-if="psp.controla_stock || esBaseDerivado">
            <v-sheet elevation="2" class="pa-4 d-flex align-center justify-center rounded-lg">
              <v-icon color="blue darken-2" size="36" class="mr-3">mdi-warehouse</v-icon>
              <div>
                <div class="text-caption font-weight-medium">Stock actual</div>
                <div class="text-h4 font-weight-bold blue--text text--darken-2">
                  {{ psp.cantidad_stock }}
                </div>
                <div v-if="esBaseDerivado" class="text-caption grey--text">
                  ~{{ psp.cantidad_stock }} {{ psp.presentacion_nombre }}
                </div>
              </div>
            </v-sheet>
          </v-col>

          <v-col cols="12" md="6" v-else>
            <v-chip color="red" text-color="white" class="ma-2">
              Control de stock desactivado
            </v-chip>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-divider class="my-2"></v-divider>

    <v-tabs background-color="transparent">
      <v-tab :to="{ name: 'empresa.sucursal.productos.item.inventario.stock' }">
        Stock
      </v-tab>
      <v-tab :to="{ name: 'empresa.sucursal.productos.item.inventario.movimientos' }">
        Movimientos
      </v-tab>
    </v-tabs>

    <v-container flat class="mt-4">
      <router-view
        :productoProp="productoProp"
        :psp="psp"
        @actualizarPsp="actualizarPsp"
      ></router-view>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "SucursalProductoInventario",
  props: {
    productoProp: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      psp: null,
    };
  },
  computed: {
    esBaseDerivado() {
      return this.psp && this.psp.tipo_stock === 'BASE' && !this.psp.es_base;
    },
    tipoStockLabel() {
      if (!this.psp) return '';
      if (this.psp.tipo_stock === 'TRANSF') return 'Transformación';
      if (this.psp.tipo_stock === 'BASE' && this.psp.es_base) return 'Stock base';
      if (this.psp.tipo_stock === 'BASE' && !this.psp.es_base) return 'Derivado';
      return 'Independiente';
    },
    tipoStockColor() {
      if (!this.psp) return 'grey';
      if (this.psp.tipo_stock === 'TRANSF') return 'deep-purple';
      if (this.psp.tipo_stock === 'BASE' && this.psp.es_base) return 'blue darken-1';
      if (this.psp.tipo_stock === 'BASE' && !this.psp.es_base) return 'teal';
      return 'grey darken-1';
    },
  },
  methods: {
    actualizarPsp(updatedPsp) {
      this.psp = updatedPsp;
    },
  },
  watch: {
    productoProp: {
      handler(newVal) {
        if (newVal) this.psp = { ...newVal };
      },
      immediate: true,
    },
  },
};
</script>
